export default "<router-outlet *ngIf=\"true\"></router-outlet>\r\n"